module.exports = __webpack_public_path__ + "img/noAccounts.f1bef519.svg";